import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    sidebarOpen: true,
    location: [],
    favourites: [],
    orders: [],
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    addToFavourites: (state, action) => {
      const product = action.payload;
      const exists = state.favourites.find((p) => p.id === product.id);
      if (!exists) state.favourites.push(product);
    },
    removeFromFavourites: (state, action) => {
      state.favourites = state.favourites.filter(
        (p) => p.id !== action.payload
      );
    },
  },
});

export const { toggleSidebar, setLocation, addToFavourites, removeFromFavourites } =
  uiSlice.actions;
export default uiSlice.reducer;
